import React from 'react'
import loadMoreImg from "../../../img/arrow/loadMore.png";
import styled from 'styled-components'

const LoadMoreWrapper = styled.div`
  text-align: center;
  color: #bfbfbf;
  margin-top: 8px;
  cursor: pointer;
  user-select: none;
  .line {
    width: 100%;
    margin-bottom: 8px;
    height: 1px;
    border-top: 2px dashed #E9E9E9;
  }
  span {
    font-size: 12px;
    margin-left: 8px;
  }
`

const LoadMore = (props) => {
  return (
    <LoadMoreWrapper onClick={() => props.onClick()}>
      <img src={loadMoreImg} alt="展开更多"/>
      <span>展开更多</span>
    </LoadMoreWrapper>
  )
}

export default LoadMore
